<template>
  <div>
    <v-dialog
    @keydown.esc="isOpen=false"
    style="z-index: 9999"
    v-model="isOpen"
    persistent
    max-width="450px">
      <v-card>
        <v-card-title>
          <span class="headline">Aviso de cookies</span>
        </v-card-title>
        <v-divider />
        <br>
        <v-card-text class="text-justify">
          <span>
            Te informamos que nosotros y nuestros proveedores usamos cookies y tecnologías similares en nuestro sitio web para analizar su uso para fines de investigación de mercado o publicidad y para proporcionarle funciones adicionales.
            Los datos que recabamos son:
            <ul>
              <br>
              <li>Nombres y apellidos</li>
              <li>Correo electrónico</li>
              <li>Navegador</li>
              <li>Sistema Operativo</li>
              <li>Tiempo de permanencia en el sistema</li>
              <li>País desde el cuál se accede</li>
            </ul>
            <br>
          Al dar clic en “Aceptar“ y permanecer en nuestra web, se tomará como que usted está de acuerdo. Consulte nuestro aviso de privacidad para más información.
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="error" text @click="closeDialog">Rechazar</v-btn> -->
          <v-btn color="primary" text @click="submit">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'
import moment from 'moment'

export default {
  data () {
    return {
      overlay: false,
      isOpen: false
    }
  },
  methods: {
    openDialog () {
      this.isOpen = true
    },
    closeDialog: function () {
      this.isOpen = false
    },
    async submit () {
      this.overlay = true
      let cookie = VueCookie.get('expirationDate')
      if (!cookie || cookie < new Date()) {
        const actualDate = new Date()
        cookie = VueCookie.set('expirationDate', moment(actualDate.setDate(actualDate.getDate() + 15)).format('YYYY-MM-DD'), { expires: 15 })
      }
      this.$toasted.show('Los términos fueron aceptados correctamente.', { duration: 3000 })
      this.overlay = false
      this.closeDialog()
    }
  }
}
</script>
